React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')

module.exports = class OrganizationMembersFilterListComponent extends React.Component

  constructor: (props) ->
    super
    @state =
      showingAll: false

  render: t.renderable ->
    {
      canShowAll,
      openManageMembers,
      filter,
      onFilterChange,
      onShowAllChange,
      memberTypeFilter,
      onMemberTypeChange,
      orgIsEmpty,
      orgMemberCount,
      guestMemberCount
    } = @props
    { showingAll } = @state

    toggleShowingAll = =>
      showingAll = !@state.showingAll
      @setState({ showingAll })
      onShowAllChange(showingAll)

    t.div ->
      t.div '.org-members-page-navigation-list', ->
        t.div '.org-members-options', ->
          t.div '.org-members-filter-list', ->
            t.h1 -> t.format 'members-of-team-boards'
            t.ul '.org-members-filter', ->
              t.li ->
                t.a {
                  className: 'active' if memberTypeFilter == 'team-member'
                  href: '#'
                  onClick: (e) => onMemberTypeChange('team-member')
                }, ->
                  t.format 'team-members'
                  if !orgIsEmpty
                    t.raw '&nbsp;'
                    t.text "(#{ orgMemberCount })"

              t.li ->
                t.a {
                  className: 'active' if memberTypeFilter == 'guest'
                  href: '#'
                  onClick: (e) => onMemberTypeChange('guest')
                }, ->
                  t.format 'guests'
                  if guestMemberCount
                    t.raw '&nbsp;'
                    t.text "(#{ guestMemberCount })"



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-members-filter-list-component.coffee